import React, { useState, useEffect, useContext, useRef } from 'react'
import { SnackbarContext } from 'components';


export const useSnackbar = () => {
    const snackbar = useContext(SnackbarContext);
   
    return [snackbar.open]
}
